/* eslint-disable no-unused-vars */
import React, { useContext } from "react";
import ConfigurationContext from "../../src/context/Configuration";

const LIBRARIES = ["places", "drawing", "geometry", "localContext", "visualization"];

const ConfigurableValues = () => {
  const configuration = useContext(ConfigurationContext);

  const SERVER_URL = process.env.REACT_APP_SERVER_URL || "http://localhost:8001/";
  const WS_SERVER_URL = process.env.REACT_APP_WS_SERVER_URL || "ws://localhost:8001/";


  const GOOGLE_CLIENT_ID = configuration?.webClientID;
  const STRIPE_PUBLIC_KEY = configuration?.publishableKey;
  const NMI_TOKENIZATION_KEY = configuration?.nmiTokenizationKey;
  const PAYPAL_KEY = configuration?.clientId;
  const GOOGLE_MAPS_KEY = configuration?.googleApiKey;
  const MAPBOX_TOKEN =
    configuration?.mapboxToken || process.env.REACT_APP_MAPBOX_TOKEN;
  const AMPLITUDE_API_KEY = configuration?.webAmplitudeApiKey;
  const COLORS = {
    GOOGLE: configuration?.googleColor,
  };
  const SENTRY_DSN = configuration?.webSentryUrl;
  const SKIP_EMAIL_VERIFICATION = configuration?.skipEmailVerification;
  const SKIP_MOBILE_VERIFICATION = configuration?.skipMobileVerification;
  const VAPID_KEY = configuration?.vapidKey;

  return {
    SERVER_URL,
    WS_SERVER_URL,
    GOOGLE_CLIENT_ID,
    COLORS,
    PAYPAL_KEY,
    STRIPE_PUBLIC_KEY,
    NMI_TOKENIZATION_KEY,
    GOOGLE_MAPS_KEY,
    MAPBOX_TOKEN,
    AMPLITUDE_API_KEY,
    LIBRARIES,
    SENTRY_DSN,
    SKIP_EMAIL_VERIFICATION,
    SKIP_MOBILE_VERIFICATION,
    VAPID_KEY,
  };
};

export default ConfigurableValues;
